import styled from "styled-components";
import CustomExclamationHover from "./CustomExclamationHover";
import { FormTitleInterface } from "../../Models/Common/FormFieldComponentInterfaces";

const StyledTitleLabel = styled.label`
        color: ${(props) => props.theme.secondaryText};
        font-size: 12px;
        // font-weight: 600;
        font-weight: 500;
        align-self: center;
        align-items: center;
        display: flex;
        // margin: 10px 0px;
        color: #6179b3;
`
const RequiredIndicator = styled.div`
    color: var(--textDangerColor);
    font-size: 13px;
    font-weight: 600;
    margin: 0px 0px 0px 5px;
`;

const CustomFormTitle = (fieldProps: FormTitleInterface) => {
    return !fieldProps.hideLabel ? <StyledTitleLabel>
        {<div style={{ display: 'flex', alignContent: 'center', marginBottom: '3px'}}>
            {/* ---------TITLE---------- */}
            <div>{fieldProps.title}</div>

            {/* ---------TOOLTIP---------- */}
            {fieldProps.exclamationHoverItemDisplayText &&
                <CustomExclamationHover hoverText={fieldProps.exclamationHoverItemDisplayText ?? ''} />
            }

            {/* ---------IS REQUIRED INDICATOR---------- */}
            <RequiredIndicator>{!fieldProps.hideLabel && fieldProps.required ? "*" : ""}</RequiredIndicator>
        </div>}
    </StyledTitleLabel> : <></>
}

export default CustomFormTitle;